module.exports = __webpack_public_path__ + "img/33_42.8eb7cbcc.png";